/**
 * AI:
 * Status: "in progress"
 * Type: Component
 * SubType: CrudIntegration
 * Reason: Side view for LogicFlow OBC — compact layout with overview, designer, and tests navigation items.
 */
import {Component, OnInit} from '@angular/core';
import {LgLogicFlowObjectBaseComponent} from "../lg-logic-flow-object-base.component";

@Component({
    selector: 'mvs-lg-logic-flow-object-component-side',
    templateUrl: 'lg-logic-flow-object-side.component.html',
    // TM-1000001563: aligns side view host sizing with the full view so the
    // embedded <lg-flow-designer> renders identically (same flex column,
    // same definite height) inside the OBC side drawer.
    styleUrls: ['lg-logic-flow-object-side.component.scss'],
    standalone: false
})
export class LgLogicFlowObjectSideComponent extends LgLogicFlowObjectBaseComponent implements OnInit {

    /**
     * load and initialize sidebar navigations
     */
    loadSideBarMenuItems() {
        this.navigationItems = [
            {
                label: 'overview',
                action: 'overview',
                tooltip: 'Übersicht',
                icon: 'fa-regular fa-circle-info',
                toggleable: false,
                default: true
            },
            {
                label: 'designer',
                action: 'designer',
                tooltip: 'Flow-Designer',
                icon: 'fa-regular fa-bezier-curve',
                toggleable: false,
            },
            {
                label: 'tests',
                action: 'tests',
                tooltip: 'Testfälle',
                icon: 'fa-regular fa-flask-vial',
                toggleable: false,
            },
        ];

        this.activeNavigationItem = this.navigationItems[0];
        this.handleNavigationItemsChange();
    }
}
